import api from "./axios";

export const delete_employer_by_url = (url) => api.delete(url);
export const update_employer_by_url = (url, data) => api.patch(url, data);
export const plan_list = (employer_id) => api.get(`/employer/${employer_id}/employee/plan`);
export const plan_list_all = (employer_id) => api.get(`/employer/${employer_id}/employee/plan?allPlans=true`);
export const employee_list = (employer_id) => api.get(`/employer/${employer_id}/employee`);
export const employee_plan_balances = (employer_id) => api.get(`/employer/${employer_id}/employee/plan/balances`);
export const employee_summaries = (employer_id) => api.get(`/employer/${employer_id}/plan/v2/summaries`);
export const reimbursementSummary = (employer_id) => api.get(`/employer/${employer_id}/reimbursementSummary`);
export const premiumSummary = (employer_id) => api.get(`/employer/${employer_id}/premiumSummary`);
export const achTransactionSummary = (employer_id, afterTs) => api.get(`/nacha/ach/employer/svb?employerId=${employer_id}&afterTs=${afterTs}`);
export const achTransactionSummaryEmployer = (employer_id, afterTs) => api.get(`/nacha/ach/employer/svb/${employer_id}?afterTs=${afterTs}`);
export const billingHistorySummary = (employer_id) => api.get(`/employer/${employer_id}/billingHistorySummary`);
export const allocationScheduleSummary = (employer_id) => api.get(`/employer/acaCompliantSchedule/${employer_id}`);
export const reportSummary = (employer_id) => api.get(`/employer/${employer_id}/report`);
export const plan_document_summary = (employer_id) => api.get(`/employer/${employer_id}/plan/document`);
export const admin_list = (employer_id) => api.get(`/employer/${employer_id}/admins`);
export const save_user = (employer_id, userData) => api.post(`/employer/${employer_id}/user`, userData);
export const get_employee = (employer_id, user_id) => api.get(`/employer/${employer_id}/user/${user_id}`);
export const terminate_employee = (employer_id, user_id, data) => api.post(`/employer/${employer_id}/user/${user_id}/terminate`, data);
export const remove_terminate_employee = (employer_id, user_id) => api.delete(`/employer/${employer_id}/user/${user_id}/terminate`);
export const update_user = (employer_id, user_id, userData) => api.post(`/employer/${employer_id}/user/${user_id}`, userData);
export const get_plan_details = (employer_id) => api.get(`/employer/${employer_id}/planDetails`);
export const charge_one_time = (url, data) => api.post(`${url}`, data);
export const assign_admin_role = (employer_id, admin_id, role) =>
  api.post(`/employer/${employer_id}/admins/${admin_id}/${role}`);

export const remove_admin_role = (employer_id, admin_id) =>
  api.delete(`/employer/${employer_id}/admins/${admin_id}`);

export const update_admin_settings = (employer_id, admin_id, payload) =>
  api.patch(`/employer/${employer_id}/admins/${admin_id}`, payload);

export const employer_engagement_summary = (config) =>
  api.get(`/employer/engagementSummary`, config);

export const employer_billing = (config) =>
  api.get(`/employer/billing`, config);

export const resend_employer_charge = (employerId, employerInvoiceChargeId, config) =>
    api.post(
        `/employer/${employerId}/billing/charge/${employerInvoiceChargeId}/resend`,
        {},
        config,
    );
    
export const get_employer_class = (employer_id, class_id, config) =>
  api.get(`/employer/${employer_id}/class/${class_id}`, config);

export const attach_employer = (employer_id, data) => api.patch(`/employer/${employer_id}/attach`, data);
export const attach_employee = (user_id, token) => api.post(`/user/${user_id}/login`);
export const get_employer_details = (employer_id) => api.get(`/employer/${employer_id}?attributes[include]=providerSpecificData`);
export const get_valid_plans = (employer_id) => api.get(`/employer/${employer_id}/plan/v2/validPlans`);
export const get_all_plans = (employerId) => api.get(`/employer/${employerId}/plan/v2/allPlans`);

export const remove_employee_from_eligible = (employee_id, plan_id) => api.delete(`/employee/${employee_id}/plan/eligible/${plan_id}`);
export const send_employee_invite = (plan_id) => api.post(`employeeInvite/userPlan/${plan_id}`)
export const send_bulk_employee_invite = (employer_plan_id) => api.post(`/employeeInvite/employerPlan/${employer_plan_id}`);
export const update_plan_details = (user_id, plan_id, data) => api.patch(`/employee/${user_id}/plan/${plan_id}`, data);

export const change_email = (data) => api.post(`/user/email`, data);
export const change_password = (data) => api.post(`/user/password`, data);
export const get_user = (email) => api.get(`/user/v2?email=${encodeURIComponent(email)}`);
export const create_admin = (employer_id, data) => api.post(`/employer/${employer_id}/admins`, data);
export const get_admin = (employer_id, admin_id) => api.get(`/employer/${employer_id}/admins/${admin_id}`);
export const get_claims = (employer_id, paramsString) => api.get(`/employer/${employer_id}/claims?${paramsString}`);
export const get_allocations = (employer_id, paramsString) => api.get(`/employer/${employer_id}/allocations?${paramsString}`);
export const get_employee_census = (employer_id) => api.get(`/employer/${employer_id}/employeeCensus`);
export const get_ach_transactions = (employer_id) => api.get(`/nacha/ach/employer/svb/${employer_id}`);
export const get_billing_history = (employer_id) => api.get(`/employer/${employer_id}/billing/invoice`);
export const get_reports = (employer_id) => api.get(`/employer/${employer_id}/report`);
export const get_documents = (employer_id) => api.get(`/employer/${employer_id}/plan/document`);
export const get_approved_expenses_report = (employerId, employeeId, config = {}) =>
  api.get(`/employer/${employerId}/reports/approved-expenses`, {
    ...config,
    params: employeeId ? { employeeId } : undefined,
  });
export const get_expense_transactions_report = (employerId, employeeId, config = {}) =>
  api.get(`/employer/${employerId}/reports/expense-transactions`, {
    ...config,
    params: employeeId ? { employeeId } : undefined,
  });
export const get_account_activity_report = (employerId, employeeId, config = {}) =>
  api.get(`/employer/${employerId}/reports/account-activity`, {
    ...config,
    params: employeeId ? { employeeId } : undefined,
  });

export const process_recurring_contributions = (employer_id) => api.post(`/employer/${employer_id}/processRecurringContributions`);
export const reset_recurring_contributions = (employer_id) => api.post(`/employer/${employer_id}/resetRecurringContributions`);
export const create_plan_transactions = (employer_id) => api.post(`/employer/${employer_id}/processExpenses`);
export const create_nacha_transactions = (employer_id) => api.post(`/employer/${employer_id}/processNachaTransactions`);
export const recreate_plan_documents = (employer_id) => api.post(`/employer/${employer_id}/recreateDocuments`);
export const recreate_service_agreements = (employer_id) => api.post(`/employer/${employer_id}/recreateServiceAgreements`);
export const reset_pending_reimbursements = (employer_id) => api.post(`/employer/${employer_id}/resetPendingReimbursements`);
export const reset_ach_holds = (employer_id) => api.post(`/employer/${employer_id}/resetAchHolds`);
export const upload_employer_file = async (employer_id, file) => {
  const formData = new FormData()
  formData.append("upload", file)
  const response = await api.post(`/employer/${employer_id}/userFile`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}
export const process_employer_file = async (employer_id, userFileId) => {
  const response = await api.post(`/employer/${employer_id}/userFile/${userFileId}/process`);
  return response.data;
}
export const email_check = (employerId, email) =>
    api.get(`/employer/${employerId}/emailCheck`, { params: { email } })
export const get_all = () =>  api.get(`/employer?attributes[exclude]=providerSpecificData`);
export const get_one = (employerId) => api.get(`/employer/${employerId}?attributes[include]=providerSpecificData`);
export const get_admin_all = (inputStatus) => api.get(`/admin/employers?status=${inputStatus}`);
export const sign_document = (url, data ) => api.post(`${url}`, data);
export const create_employer = (data) => api.post(`/employer`, data);
export const update_employer = (employerId, data) => api.patch(`/employer/${employerId}`, data);
export const get_plans = (employerId) => api.get(`/employer/${employerId}/plan/v2`);
export const get_plan = (employerId, planType, planId) => api.get(`/employer/${employerId}/plan/v2/${planType}/${planId}`);
export const get_plan_summary = (employerId) => api.get(`/employer/${employerId}/plan/summary`);
export const update_plan = (params, payload) => api({
    method: params.link.method,
    url: params.link.url,
    data: payload,
});
export const rollover_plan = (params) => api({
    method: params.link.method,
    url: params.link.url,
});
export const delete_plan = (params) => api({
    method: params.link.method,
    url: params.link.url,
});
export const get_bank_accounts = (employerId) => api.get(`/employer/${employerId}/bankAccount?includeNumbers=true`);
export const get_bank_accounts_no_employer = () => api.get(`/employer/bankAccount?includeNumbers=true`);
export const get_bank_account = (employerId, bankAccountId) => api.get(`/employer/${employerId}/bankAccount/${bankAccountId}`);
export const update_bank_account = (employerId, bankAccountId, data) => api.patch(`/employer/${employerId}/bankAccount/${bankAccountId}`, data);
export const delete_bank_account = (employerId, bankAccountId) => api.delete(`/employer/${employerId}/bankAccount/${bankAccountId}`);
export const upload_class_max_benefit_file = async (employer_id, file) => {
  const formData = new FormData()
  formData.append("upload", file)
  return api.post(`/employer/${employer_id}/classMaxBenefitFile/view`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
